import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import { makeStyles } from '@material-ui/core/styles';
import BaseLoader from '../../UIWidgets/BaseLoader';
import {
	Card,
	CardActions,
	CardHeader,
	CardContent,
	Divider,
	Table,
	TableBody,
} from '@material-ui/core';
import PaginationView from '../../ProductList/components/pagination';
import ProductsToolbar from '../../ProductList/components/ProductsToolbar';
import { OrderTableHeader, OrderTableRow } from './orderTableView';

const useStyles = makeStyles(theme => ({
	root: {
		height: '100%',
	},
	content: {
		padding: 0,
	},
	inner: {
		minWidth: 800,
	},
	statusContainer: {
		display: 'flex',
		alignItems: 'center',
	},
	status: {
		marginRight: theme.spacing(1),
	},
	actions: { justifyContent: 'flex-end' },
}));

const OrderList = props => {
	const { className, history, staticContext, ...rest } = props;

	const classes = useStyles();

	const [orders, setOrders] = useState({});

	const [loading, setLoading] = useState(false);

	const [currentPage, setCurrentPage] = useState(1);

	const [totalResult, setTotalResult] = useState(0);

	const [totalPages, setTotalPages] = useState(0);

	const [error, setError] = useState(false);

	const [searchQuery, setQuery] = useState('');

	const numberPerPage = 10;

	const { enqueueSnackbar } = useSnackbar();

	useEffect(() => {
		const fetchOrders = async () => {
			setLoading(true);
			axios
				.get('/api/orders/all', {
					params: {
						currentPage: currentPage,
						numberPerPage: numberPerPage,
						orderId: searchQuery,
					},
				})
				.then(result => {
					const content = result.data.data;

					setLoading(false);
					setOrders({
						...orders,
						[currentPage]: content.orders,
					});
					setTotalResult(content.numOfResults);
					setTotalPages(content.pages);
				})
				.catch(error => {
					setLoading(false);
					setError(true);
					setTotalPages(0);
					setTotalResult(0);
					console.log(error);
				});
		};
		if (!orders[currentPage] && !error) fetchOrders();
	}, [currentPage, error, searchQuery]);

	const updateOrderStatus = async (id, newStatus, order) => {
		setLoading(true);
		try {
			const response = await axios.put(`/api/orders/${id}`, {
				orderStatus: newStatus,
			});

			setLoading(false);
			if (response.data.code === 200) {
				const newOrder = order;
				newOrder.status = newStatus;

				const index = orders[currentPage].findIndex(item => item._id === id);
				const currentPageOrderList = orders[currentPage];
				currentPageOrderList[index] = newOrder;

				setOrders({
					...orders,
					[currentPage]: currentPageOrderList,
				});

				enqueueSnackbar('订单状态更新成功', { variant: 'success' });
			}
		} catch (error) {
			console.log(error);
			setLoading(false);
			enqueueSnackbar('订单状态更新失败', { variant: 'error' });
		}
	};

	const onSearch = query => {
		setError(false);
		setOrders({});
		setCurrentPage(1);
		setQuery(query);
	};

	const renderTableView = loading ? (
		<BaseLoader />
	) : (
		<div className={classes.inner}>
			<Table>
				<OrderTableHeader />
				<TableBody>
					{orders &&
						orders[currentPage] &&
						orders[currentPage].map(order => (
							<OrderTableRow
								key={order._id}
								order={order}
								updateOrderStatus={updateOrderStatus}
							/>
						))}
				</TableBody>
			</Table>
		</div>
	);

	const pageLess = () => {
		if (currentPage > 1) setCurrentPage(currentPage - 1);
	};

	const pageMore = () => {
		if (currentPage < totalPages) setCurrentPage(currentPage + 1);
	};

	return (
		<>
			<ProductsToolbar
				placeholder='输入订单号搜索'
				onSearch={onSearch}
				showRightButton={false}
			/>
			<div style={{ height: '15px' }}></div>
			<Card {...rest} className={clsx(classes.root, className)}>
				<CardHeader title='订单列表' />
				<Divider />
				<CardContent className={classes.content}>
					<PerfectScrollbar>{renderTableView}</PerfectScrollbar>
				</CardContent>
				<Divider />
				<CardActions className={classes.actions}>
					<PaginationView
						currentPage={currentPage}
						numberPerPage={numberPerPage}
						totalResult={totalResult}
						pageLess={pageLess}
						pageMore={pageMore}
					/>
				</CardActions>
			</Card>
		</>
	);
};

OrderList.propTypes = {
	className: PropTypes.string,
};

export default withRouter(OrderList);
